<template>
  <div class="uni-collapse">
    <el-collapse v-model="activeName">
      <el-collapse-item class="uni-collapse-item" :name="name">
        <template slot="title">
          <div class="header">
            <div style="display: flex; align-items: center">
              <i class="el-icon-arrow-up"></i>
              <i class="iconfont icon123 gray-light"></i>
              <span class="cell-title">{{ title }}</span>
            </div>

            <div class="refresh-box">
              <slot name="title-right">
                <template v-if="datas.length == 0">
                  <i class="iconfont iconV_heziguanli-dengdaigengxin"></i>
                  <span>待更新</span>
                </template>
              </slot>
            </div>
          </div>
        </template>

        <slot name="collapseContent">
          <div
            class="collapse-cell"
            v-for="item in datas"
            :key="item.studentUuid"
          >
            <div class="title-box item">
              <i v-if="item.isFinish" class="iconfont icongouxuan primary"></i>
              <el-progress
                style="vertical-align: middle"
                v-else
                :width="40"
                :strokeWidth="2"
                color="#2E58FF"
                type="circle"
                :percentage="item.studyProgress || 0"
              ></el-progress>
              <span class="span tit">{{ item.title }}</span>
              <span v-if="item.videoid" class="span">{{
                item.duration | formatSeconds
              }}</span>
              <span class="span" v-else>暂无课程视频</span>
            </div>

            <div class="item">
              <span
                style="margin-left: 100px"
                :class="getCourseClass(item.studyProgress).style"
                >{{ getCourseClass(item.studyProgress).txt }}</span
              >
            </div>

            <div class="item">
              <template v-if="item.workTotal > 0">
                <span class="span">
                  <i
                    class="iconfont icongouxuan primary"
                    v-if="item.workFinish"
                  ></i>
                  <i class="iconfont iconjinzhi-yin gray-light" v-else></i>
                  作业练习
                </span>
                <span class="oringe" v-if="item.isJobComplete">* 必须完成</span>
              </template>
              <div v-else>无作业练习</div>
            </div>
            <div>
              <span class="span">
                <el-button
                  v-if="item.videoid"
                  class="uni-link-btn"
                  type="primary"
                  icon="el-icon-video-play"
                  @click="jump('studyNotes', item)"
                  >{{ item.studyProgress ? "继续学习" : "开始学习" }}</el-button
                >
                <el-button
                  v-else
                  class="uni-disabled-btn"
                  type="info"
                  icon="el-icon-video-play"
                  disabled
                  >开始学习</el-button
                >
              </span>
            </div>
          </div>
        </slot>
      </el-collapse-item>
    </el-collapse>

    <!-- 提示框 -->
    <ComponentDialog1
      icon="fail"
      :title="dialogTitle"
      :visible.sync="isDialogVisible"
      @confirm="isDialogVisible = !isDialogVisible"
      :showCancelBtn="false"
      confirmText="确定"
    ></ComponentDialog1>
  </div>
</template>

<script>
import { unsafeGetVideoUrl } from "@/api/basic";
export default {
  name: "ComponentCollapse",
  props: {
    name: {
      type: Number,
      default: 0,
    },
    // 标题
    title: {
      type: String,
      default: "马克思",
    },
    // 数据
    datas: {
      type: Array,
      default: () => [],
    },
    activeNames: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isDialogVisible: false,
      dialogTitle: "",
      activeName: "",
      data: [
        {
          name: "1",
          age: 12,
          isFinish: true,
        },
        {
          name: "2",
          age: 12,
          isFinish: false,
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.activeName = this.activeNames;
    }, 100);
  },
  methods: {
    activeNamesGoTo(uuid) {
      this.activeName.push(uuid);
    },
    jump(name, item) {
      unsafeGetVideoUrl(item.lessonsUuid).then((datas) => {
        const res = datas.data;
        if (res.code == 0 && res.data.playAuth) {
          this.$router.push({
            name: name,
            query: {
              courseUuid: this.$route.query.id,
              lessonsUuid: item.lessonsUuid,
            },
          });
        } else if (res.message) {
          this.isDialogVisible = true;
          this.dialogTitle = res.message;
        }
      });
    },
    // 获取课节状态class
    getCourseClass(progress) {
      if (progress == null) {
        return {
          txt: "未开始",
          style: "primary",
        };
      } else if (progress == "100") {
        return {
          txt: "已完成",
          style: "oringe",
        };
      } else {
        return {
          txt: "学习中",
          style: "success",
        };
      }
    },
  },
};
</script>

<style lang="scss">
.uni-collapse {
  .el-collapse-item__header {
    height: 65px;
    line-height: 65px;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
    font-size: 14px;
  }
  .el-collapse-item__arrow {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.uni-collapse {
  margin-bottom: 8px;

  .header {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding-left: 40px;
    font-size: 14px;
    font-weight: 500;

    .iconfont {
      vertical-align: middle;
      margin: 0 7px;
      font-size: 40px;
    }
    .cell-title {
      display: inline-block;
      width: 250px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .refresh-box {
      color: $textGray;
      margin-right: 40px;
      .iconfont {
        font-size: 16px;
      }
    }
  }
  .el-icon-arrow-up {
    transition: all 0.3s;
  }
  .uni-collapse-item {
    &.is-active {
      .el-icon-arrow-up {
        transform: rotate(180deg);
      }
    }
  }
  .collapse-cell {
    display: flex;
    padding: 25px 20px 25px 70px;
    align-items: center;
    border-top: 1px solid #ebebeb;
    // height: 50px;
    background: #f8f9fb;
    // justify-content: space-between;
    color: $grayColor !important;

    .item {
      flex: 1;
    }

    .title-box {
      flex: 2;
      display: flex;
      align-items: center;
    }

    .iconfont {
      vertical-align: middle;
      font-size: 25px;
      margin: 0 8px;
    }

    .tit {
      display: inline-block;
      width: 400px;
      margin-left: 25px;
    }

    &:hover {
      background: #f5fdff;

      .tit {
        @include fontColor("primary");
      }
    }

    .span {
      margin-right: 16px;
    }
  }
  .uni-link-btn {
    @include uni-link-btn;
    margin-left: 40px;
  }

  .uni-disabled-btn {
    min-width: 80px;
    padding: 4px 8px;
    font-size: 12px;
    margin-left: 40px;
  }
}
</style>
